import React, {
 useCallback,
 useEffect,
 useMemo,
 useState,
 Suspense,
} from "react";
import {
 deleteItem,
 fetchData,
 toggleStatus,
} from "../../../utils/apiUtils";
import {PlusButton } from "../../../helper/ImageFormat";
import DeleteModel, {
} from "../../../Components/DeleteModel";
import Breadcrumb from "../../../helper/Breadcrumb";
import PermissionTable from "./PermissionTable";
import { PermissionModel } from "../../../Model/Model";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import { useLocation } from "react-router-dom";
import BackButton from "../../../Components/BackButton";
import { fetchAllData } from "../../../helper/ProductAttributeHandling";

const Permission = () => {
  const location = useLocation();
  const id = location.state;
 const [loading, setLoading] = useState(true);
 const [permission, setpermission] = useState([]);
 const [editingId, setEditingId] = useState(null);
 const [search, setSearch] = useState("");
 const [deleteItemId, setDeleteItemId] = useState(null);
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const [modalOpen, setModalOpen] = useState(false);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [updatedata, setupdatedata] = useState(null);
 const [isDeleting, setIsDeleting] = useState(false);
 const [pageData,setPageData]=useState([])
 const [allpermission,setAllPermission]=useState([])
 const totalPages = useMemo(
  () => Math.ceil(totalCount / perPage),
  [totalCount, perPage]
 );

 const handleEditClick = (data) => {
  setEditingId(data.id);
  const { createdAt, id, updatedAt, isActive, ...otherData } = data;
  setupdatedata(otherData);
  setModalOpen(true);
 };
const getAllPermision=async()=>{
  await fetchAllData(`permission-pagination?role_id=${id}`,setAllPermission)
}
  useEffect(()=>{
 getAllPermision()
  },[])

 const fetchpermission = useCallback(
  async (page = 1, searchQuery = "") => {
   setLoading(true);
   await fetchData(
    "permission-pagination",
    { 
      perPage,
      pageNo: page, 
      search: searchQuery,
      role_id: id
    },
    setpermission,
    setTotalCount,
    setCurrentPage,
    setLoading
   );
  },
  [perPage]
 );

 useEffect(() => {
  const delay = search ? 500 : 0;
  const handler = setTimeout(() => {
   fetchpermission(1, search);
    fetchAllData("/page", setPageData)
  }, delay);

  return () => clearTimeout(handler);
 }, [search, perPage]);


 

 const handleDelete = async (data) => {
  setDeleteItemId(data.id);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("permission", deleteItemId, fetchpermission,[]);
   setDeleteItemId(null);
   setDeleteModalOpen(false);
   return res;
  } catch (err) {
   throw err;
  } finally {
   setIsDeleting(false);
  }
 };

 const handleStatusToggle = async (item) => {
  const data = await toggleStatus(
   "currency-status",
   item?.id,
   fetchpermission
  );
  if (Object.keys(data).length > 0) {
   setpermission((prevpermission) =>
    prevpermission.map((curr) =>
     curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchpermission(page);
  }
 };
 const toggleModal = () => {
  setModalOpen(!modalOpen);
  setEditingId(false);
  setupdatedata({});
 };

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Permissions", path: "*" },
 ];

 

 return (
  <>
   <div className="content-wrapper">
    <div
     className="page-header mt-5"
     style={{ display: "flex", justifyContent: "space-between" }}
    >
     <h3 className="custom-page-title">Permissions</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
      <PerPageSelect value={perPage} onChange={setPerPage}/>

     <div style={{ display: "flex", gap: "20px" }}>
      <BackButton to={"/role"}/>
      <TableSearch value={search} onChange={setSearch} />
      <PlusButton handleAdd={toggleModal} module={"Permission"} />

     </div>
    </div>

    <PermissionTable
     loading={loading}
     permission={permission}
     currentPage={currentPage}
     perPage={perPage}
     totalPages={totalPages}
     totalCount={totalCount}
     handlePageClick={handlePageClick}
     handleEditClick={handleEditClick}
     handleDelete={handleDelete}
     handleStatusToggle={handleStatusToggle}
    />
   </div>

   <Suspense fallback={<div>Loading...</div>}>
    {modalOpen && (
     <PermissionModel
      modalOpen={modalOpen}
      toggleModal={toggleModal}
      editingId={editingId}
      setEditingId={setEditingId}
      setupdatedata={setupdatedata}
      updatedata={updatedata}
      fetchpermission={fetchpermission}
      getAllPermision={getAllPermision}
      role_id={id}
      pageData={pageData}
      permission={allpermission}
     />
    )}
   </Suspense>

   <Suspense fallback={<div>Loading...</div>}>
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="Permission"
     isDeleting={isDeleting}
    />
   </Suspense>
  </>
 );
};

export default Permission;
